module.exports = __webpack_public_path__ + "static/GoodEnergyQuizIcon-6cd38c9620ac3afe9003b3e61deb0bad.png";